import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame"]

  connect() {
    const QRCODE_TTL_IN_MSECS = 60_000 // 60 sec / 1 minute
    const REFRESH_TIME_LIMIT_IN_MSECS = 1_800_000 // 1800 sec / 30 minutes

    setInterval(() => this.frameTarget.reload(), QRCODE_TTL_IN_MSECS);
    setTimeout(() => window.location.assign("https://heychimpy.com"), REFRESH_TIME_LIMIT_IN_MSECS);
  }
} 
